import { render, staticRenderFns } from "./JLjhTable.vue?vue&type=template&id=ed79c976&scoped=true"
import script from "./JLjhTable.vue?vue&type=script&lang=js"
export * from "./JLjhTable.vue?vue&type=script&lang=js"
import style0 from "./JLjhTable.vue?vue&type=style&index=0&id=ed79c976&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed79c976",
  null
  
)

export default component.exports